<ng-container *transloco="let t; read: 'partials.backbutton'">
    <a routerLink="'/ac/dashboard'" pTooltip="{{ t('back_to_angenda') }}" role="link"><fa-icon [icon]="faChevronLeft"></fa-icon></a>
</ng-container>
